var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGeneral = function SvgGeneral(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#gfilter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96 184C146.81 184 188 142.81 188 92C188 41.1898 146.81 0 96 0C45.1898 0 4 41.1898 4 92C4 142.81 45.1898 184 96 184Z",
    fill: "#23476C"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.0234 108.898V103.695C85.0234 99.1953 85.9844 95.2812 87.9062 91.9531C89.8281 88.625 93.3438 85.0859 98.4531 81.3359C103.375 77.8203 106.609 74.9609 108.156 72.7578C109.75 70.5547 110.547 68.0938 110.547 65.375C110.547 62.3281 109.422 60.0078 107.172 58.4141C104.922 56.8203 101.781 56.0234 97.75 56.0234C90.7188 56.0234 82.7031 58.3203 73.7031 62.9141L66.0391 47.5156C76.4922 41.6563 87.5781 38.7266 99.2969 38.7266C108.953 38.7266 116.617 41.0469 122.289 45.6875C128.008 50.3281 130.867 56.5156 130.867 64.25C130.867 69.4062 129.695 73.8594 127.352 77.6094C125.008 81.3594 120.555 85.5781 113.992 90.2656C109.492 93.5938 106.633 96.125 105.414 97.8594C104.242 99.5938 103.656 101.867 103.656 104.68V108.898H85.0234ZM82.7734 132.945C82.7734 129.008 83.8281 126.031 85.9375 124.016C88.0469 122 91.1172 120.992 95.1484 120.992C99.0391 120.992 102.039 122.023 104.148 124.086C106.305 126.148 107.383 129.102 107.383 132.945C107.383 136.648 106.305 139.578 104.148 141.734C101.992 143.844 98.9922 144.898 95.1484 144.898C91.2109 144.898 88.1641 143.867 86.0078 141.805C83.8516 139.695 82.7734 136.742 82.7734 132.945Z",
    fill: "#EDEDED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "gfilter0_d",
    x: 0,
    y: 0,
    width: 192,
    height: 192,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 62.0391,
    y: 38.7266,
    width: 72.8281,
    height: 114.172,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
};
export default SvgGeneral;